/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const UserDelete = {
  id: 'user.delete',
  tag: 'User',
  summary: 'Delete a user',
  description: 'Delete a user',
  method: 'delete',
  flags: { isAuthorized: true },
  route: () => `/user`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
